var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      ref: "container",
      staticClass: "z-page-nav js-top-text is-animate js-z-page-nav",
      class: [
        _vm.classForOpenedWrapper,
        { "z-page-nav--single": _vm.dataItems.length === 0 }
      ]
    },
    [
      _c("span", {
        ref: "section",
        domProps: { innerHTML: _vm._s(_vm.section) },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.toggleWrapper()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "ul",
        { ref: "list", staticClass: "z-page-nav__list ul--clear" },
        [
          _vm._l(_vm.dataItems, function(item, i) {
            return _c("li", { key: i, staticClass: "z-page-nav__item" }, [
              _c("a", {
                staticClass: "link z-page-nav__link",
                attrs: { href: item.href },
                domProps: { innerHTML: _vm._s(item.title) }
              })
            ])
          }),
          _vm._v(" "),
          _vm.extraItems.length > 0
            ? _c("li", { staticClass: "z-page-nav__item col-mobile-hide" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "link z-page-nav__link z-page-nav__popup-btn js-z-page-nav-popup__btn js-z-page-nav-popup__item",
                    class: _vm.classForOpened,
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.toggleContainer()
                      }
                    }
                  },
                  [_vm._v("Еще")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.extraItems.length > 0
            ? _c(
                "li",
                { staticClass: "z-page-nav__further col-default-hide" },
                _vm._l(_vm.extraItems, function(item, i) {
                  return _c("a", {
                    key: i,
                    attrs: { href: item.href },
                    domProps: { innerHTML: _vm._s(item.title) }
                  })
                }),
                0
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.extraItems.length > 0
        ? _c(
            "div",
            {
              staticClass:
                "z-page-nav__popup js-z-page-nav-popup__container js-z-page-nav-popup__item col-mobile-hide",
              class: _vm.classForOpened
            },
            _vm._l(_vm.extraItems, function(item, i) {
              return _c("a", {
                key: i,
                attrs: { href: item.href },
                domProps: { innerHTML: _vm._s(item.title) }
              })
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc5d4e56", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc5d4e56","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/components/page-nav/page-nav.vue
// module id = 83
// module chunks = 0